/**
 * CardCamera, the Android scanner's native camera.
 *
 * Android only. iOS keeps @capgo/camera-preview. The plugin shows a CameraX
 * preview behind the web view, runs the card detector on the device against
 * the guide rectangle we hand it, and sends back numbers, never frames. A
 * capture comes back already cropped to the card as two small JPEGs.
 *
 * Source: android/app/src/main/java/com/k2coach/cardchaseapp/cardcamera/.
 */

import { Capacitor, registerPlugin } from '@capacitor/core';

const CardCamera = registerPlugin('CardCamera');

export const isCardCameraAvailable = () => Capacitor.getPlatform() === 'android';

/**
 * Corners arrive in CSS pixels as four {x, y} points, top-left clockwise.
 * The frame overlay wants the same shape it always had.
 */
export function frameFromCorners(corners) {
  if (!Array.isArray(corners) || corners.length !== 4) return null;
  const xs = corners.map((p) => p.x);
  const ys = corners.map((p) => p.y);
  const x = Math.min(...xs);
  const y = Math.min(...ys);
  return { x, y, width: Math.max(...xs) - x, height: Math.max(...ys) - y };
}

/** Coverage scores to the boolean per-side shape the overlay reads. */
export function coverageFlags(coverage, threshold = 20) {
  const c = coverage || {};
  return {
    top: (c.top || 0) > threshold,
    bottom: (c.bottom || 0) > threshold,
    left: (c.left || 0) > threshold,
    right: (c.right || 0) > threshold,
  };
}

export default CardCamera;
